import React from 'react'
import { useGlobalKeys } from '../../hooks'
import { useGlobalContext } from '../global'
export var ODBreadcrumb = function (_a) {
  var def = _a.def
  var _b = def.component,
    _c = _b.height,
    height = _c === void 0 ? '45px' : _c,
    bg = _b.bg,
    spaceX = _b.spaceX,
    paddingLeft = _b.paddingLeft,
    activeColor = _b.activeColor,
    borderBottom = _b.borderBottom
  var convertThemeString = useGlobalContext().convertThemeString
  var menus = [
    {
      globalKey: undefined,
      title: 'MenuA',
    },
    {
      globalKey: undefined,
      title: 'MenuB',
    },
    {
      globalKey: undefined,
      title: 'MenuC',
    },
  ]
  var globalKeys = useGlobalKeys(function () {
    return menus.map(function (v) {
      return v.globalKey
    })
  })
  var wrapperStyle = {
    height: height,
    backgroundColor: convertThemeString(bg),
    paddingLeft: paddingLeft,
    borderBottom: convertThemeString(borderBottom),
  }
  var liStyle = {
    paddingTop: 1,
    color: convertThemeString(activeColor),
  }
  return React.createElement(
    'div',
    { className: 'w-full m-0 p-0 flex flex-row items-center', style: wrapperStyle },
    React.createElement(
      'ul',
      { className: 'flex flex-row space-x-' + spaceX },
      menus.map(function (m, index) {
        var gk = globalKeys[index]
        return React.createElement(
          'li',
          { key: gk + '_' + index, className: 'od-breadcrumb-item text-sm', style: liStyle },
          m.title
        )
      })
    )
  )
}
//# sourceMappingURL=ODBreadcrumb.js.map
